var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck, "_classCallCheck");
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
__name(_defineProperties, "_defineProperties");
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: false }), e;
}
__name(_createClass, "_createClass");
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
__name(_callSuper, "_callSuper");
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
__name(_possibleConstructorReturn, "_possibleConstructorReturn");
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
__name(_assertThisInitialized, "_assertThisInitialized");
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct = /* @__PURE__ */ __name(function _isNativeReflectConstruct2() {
    return !!t;
  }, "_isNativeReflectConstruct"))();
}
__name(_isNativeReflectConstruct, "_isNativeReflectConstruct");
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t2) {
    return t2.__proto__ || Object.getPrototypeOf(t2);
  }, _getPrototypeOf(t);
}
__name(_getPrototypeOf, "_getPrototypeOf");
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf(t, e);
}
__name(_inherits, "_inherits");
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t2, e2) {
    return t2.__proto__ = e2, t2;
  }, _setPrototypeOf(t, e);
}
__name(_setPrototypeOf, "_setPrototypeOf");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
import React, { Children, Component } from "react";
import classNames from "classnames";
import { BoxTabsItem } from "./Item";
import { tabsCls, tabsControlsCls, tabsControlsInitCls, tabsPaneWrapperCls, tabsPaneCls, tabsActiveCls } from "./Tabs.less";
var BoxTabs = /* @__PURE__ */ function(_Component) {
  function BoxTabs2(props) {
    var _this;
    _classCallCheck(this, BoxTabs2);
    _this = _callSuper(this, BoxTabs2, [props]);
    _this.state = {
      selectedTab: _this.props.initial
    };
    _this.bindMethods();
    return _this;
  }
  __name(BoxTabs2, "BoxTabs");
  _inherits(BoxTabs2, _Component);
  return _createClass(BoxTabs2, [{
    key: "bindMethods",
    value: (
      /**
       * bindMethods
       */
      /* @__PURE__ */ __name(function bindMethods() {
        this.handleClick = this.handleClick.bind(this);
      }, "bindMethods")
    )
    /**
     * handleClick
     *
     * @param {number} index
     */
  }, {
    key: "handleClick",
    value: /* @__PURE__ */ __name(function handleClick(index) {
      var _this2 = this;
      return function(e) {
        e.preventDefault();
        var _this2$props = _this2.props, onChange = _this2$props.onChange, toggle = _this2$props.toggle;
        var isIndexSelected = _this2.state.selectedTab === index;
        if (!toggle && isIndexSelected) {
          return;
        }
        var updatedIndex = isIndexSelected ? null : index;
        if (typeof onChange === "function") {
          onChange(updatedIndex);
        }
        _this2.setState({
          selectedTab: updatedIndex
        });
      };
    }, "handleClick")
    /**
     * render
     */
  }, {
    key: "render",
    value: /* @__PURE__ */ __name(function render() {
      var _this3 = this;
      var selectedTab = this.state.selectedTab;
      var children = this.props.children;
      var content = {
        tabs: [],
        content: []
      };
      Children.forEach(children, function(child, idx) {
        var _child$props = child.props, icon = _child$props.icon, title = _child$props.title, disabled = _child$props.disabled, tabContent = _child$props.children;
        var isActive = !disabled && idx === selectedTab;
        content.tabs.push(/* @__PURE__ */ React.cloneElement(/* @__PURE__ */ React.createElement(BoxTabsItem, null), {
          key: idx,
          role: "tab",
          icon,
          isActive,
          onClick: _this3.handleClick(idx)
        }, title));
        content.content.push(/* @__PURE__ */ React.cloneElement(child, {
          key: idx,
          className: classNames(tabsPaneCls, _defineProperty({}, tabsActiveCls, isActive))
        }, tabContent));
      });
      return /* @__PURE__ */ React.createElement("div", {
        className: tabsCls
      }, /* @__PURE__ */ React.createElement("ul", {
        className: classNames(tabsControlsCls, _defineProperty({}, tabsControlsInitCls, selectedTab === null || selectedTab === void 0)),
        role: "tablist"
      }, content.tabs), /* @__PURE__ */ React.createElement("div", {
        className: tabsPaneWrapperCls
      }, content.content));
    }, "render")
  }], [{
    key: "getDerivedStateFromProps",
    value: /* @__PURE__ */ __name(function getDerivedStateFromProps(props, state) {
      if (props.active !== null && props.active !== void 0 && state.selectedTab !== props.active) {
        return {
          selectedTab: props.active
        };
      }
      return null;
    }, "getDerivedStateFromProps")
  }]);
}(Component);
_defineProperty(BoxTabs, "defaultProps", {
  onChange: null,
  active: null,
  initial: null,
  toggle: false
});
export {
  BoxTabs
};
